import { createStore } from "vuex";
import recordParams from "./modules/recordParams";
import department from "./modules/department";
import orders from "./modules/orders";
import complexes from "./modules/complexes";
export default createStore({
  modules: {
    recordParams,
    department,
    orders,
    complexes,
  },
});
